import { Plan } from './requests';

/**
 * Gate on this, not `creditsUsed >= creditsPerPeriod`: plans with a hardcap run
 * past their base allotment, and only the server knows the real cut-off.
 */
export const isPlanPaused = (plan: Plan | null | undefined): boolean => {
  return Boolean(plan && plan.creditStatus === 'paused');
};

/** Spent the base allotment but still running. A soft, non-blocking state. */
export const isPlanOverBaseLimit = (plan: Plan | null | undefined): boolean => {
  return Boolean(plan && plan.creditStatus === 'over_base_limit');
};
